import type { LookupItem } from '@/types/shared';

/** Picks the AR/EN label of a lookup item (grades/schools/educational administrations) for the
 * currently active i18n language. */
export function lookupLabel(item: LookupItem | null | undefined, language: string): string {
  if (!item) return '';
  return language.startsWith('ar') ? item.labelAr : item.labelEn;
}

/** Finds a lookup by id within a list fetched from `/lookups/*`. */
export function findLookup(items: LookupItem[], id: number | null | undefined): LookupItem | null {
  if (id == null) return null;
  return items.find((item) => item.id === id) ?? null;
}
